export default class Service {
  constructor(apiHandler) {
    this.apiHandler = apiHandler;
    this.baseUrl;
    this.getByKeyUrl;
    this.getByIdUrl;
    this.getAllUrl;
    this.updateUrl;
    this.createUrl;
  }

  get(endPoint, data, identifier, fullResponse) {
    return this.apiHandler.get(
      `${this.baseUrl}${endPoint}`,
      data || {},
      identifier || '',
      fullResponse,
    );
  }

  post(endPoint, data, identifier, fullResponse) {
    return this.apiHandler.post(
      `${this.baseUrl}${endPoint}`,
      data || {},
      identifier || '',
      fullResponse,
    );
  }

  postRaw(endPoint, data, identifier, fullResponse) {
    return this.apiHandler.postRaw(
      `${this.baseUrl}${endPoint}`,
      data || {},
      identifier || '',
      fullResponse,
    );
  }

  put(endPoint, data, identifier, fullResponse) {
    return this.apiHandler.put(
      `${this.baseUrl}${endPoint}`,
      data || {},
      identifier || '',
      fullResponse,
    );
  }

  putRaw(endPoint, data, identifier, fullResponse) {
    return this.apiHandler.putRaw(
      `${this.baseUrl}${endPoint}`,
      data || {},
      identifier || '',
      fullResponse,
    );
  }

  getByKey(identifier, data, fullResponse) {
    return new Promise((resolve, reject) => {
      if (!identifier) {
        reject(new Error('Key cannot be null'));
      } else {
        this.get(this.getByKeyUrl, data, identifier, fullResponse)
          .then((response) => {
            resolve(response);
          });
      }
    });
  }

  getById(identifier, data, fullResponse) {
    return this.get(this.getByIdUrl, data, identifier, fullResponse);
  }

  getAll(identifier, data, fullResponse) {
    return this.get(this.getAllUrl, data, identifier, fullResponse);
  }

  create(data, fullResponse) {
    return this.post(this.createUrl, data, null, fullResponse);
  }

  update(data, identifier, fullResponse) {
    return this.put(this.updateUrl, data, identifier, fullResponse);
  }
}
